import { render } from "./EnterTrailerRedirect.vue?vue&type=template&id=5fc557c0&scoped=true&ts=true"
import script from "./EnterTrailerRedirect.vue?vue&type=script&lang=ts"
export * from "./EnterTrailerRedirect.vue?vue&type=script&lang=ts"

import "./EnterTrailerRedirect.vue?vue&type=style&index=0&id=5fc557c0&scoped=true&lang=css"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fc557c0"]])

export default __exports__